import {Link} from 'react-router-dom';
import logo from '../../assets/images/polyglow-logo.svg';
import { homeIcons } from '../../assets/images/home';
import Vector10 from '../homeVectors/Vector10';

const Footer = () => {
    return (
        <footer>
            <Vector10 />
            <div className="footer-top">
                <div className="left-section">
                    <Link to="/" className="logo-animation">
                        <img src={logo} className="group logo-polyglow" alt="Logo Polyglow" />
                    </Link>
                    <p>Le nouvel <span>allié</span> pour apprendre <br />les langues avec une approche<br />orientée <span>business</span> !</p>
                    <div className="content">
                        <div className="download">
                            <div className="google-play">
                                <a className="btn-dl" href="#"><img src={homeIcons.google} alt="Bouton Google Play" /></a>
                            </div>
                            <div className="app-store">
                                <a className="btn-dl" href="#"><img src={homeIcons.apple} alt="Bouton App Store" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right-section">
                    <div className="footer-infos">
                        <h3>UNE QUESTION ?</h3>
                        <p>06 81 40 01 26<br />info@akcia.fr</p>
                    </div>
                    <div className="footer-links">
                        <a href="#">Mentions légales</a>
                        <a href="#">Politique de confidentialité</a>
                        <a href="#">Conditions d'utilisation</a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                © 2025 by Polyglow
            </div>
        </footer>
    );
};


export default Footer;